import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import iaImage from '../../../assets/images/ia.png';

const AiFeaturesSection = () => {
  return (
    <div style={{ 
      backgroundColor: '#1a1d24', 
      backgroundImage: `url(${iaImage})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center right',
      backgroundRepeat: 'no-repeat',
      padding: '120px 0', 
      position: 'relative', 
      overflow: 'hidden' 
    }}>
      
      {/* Overlay Escuro com gradiente para garantir leitura na esquerda e transição para o bg na direita */}
      <div style={{
        position: 'absolute',
        top: 0, left: 0, right: 0, bottom: 0,
        background: 'linear-gradient(to right, rgba(26, 29, 36, 0.95) 0%, rgba(26, 29, 36, 0.8) 40%, rgba(26, 29, 36, 0.1) 100%)',
        zIndex: 0
      }}></div>

      <Container fluid className="px-4 px-xl-5 position-relative" style={{ zIndex: 1 }}>
        <Row className="align-items-center">
          
          {/* Coluna da Esquerda: Todas as informações centralizadas à esquerda */}
          <Col lg={7} className="position-relative mb-5 mb-lg-0">
            <div style={{ animation: 'fadeInLeft 1s ease-out', marginLeft: 'clamp(0px, 4vw, 60px)' }}>
              
              <div style={{ position: 'relative', marginBottom: '1.5rem' }}>
                <div 
                  className="position-absolute text-uppercase"
                  style={{
                    fontSize: 'clamp(5rem, 11vw, 12rem)', // Flexível acompanhando o Hero
                    fontWeight: 'bold',
                    color: 'transparent',
                    WebkitTextStroke: '2px rgba(0, 243, 255, 0.4)', // Mesma opacidade dos outros
                    top: '50%',
                    left: '0', 
                    zIndex: 0,
                    pointerEvents: 'none',
                    userSelect: 'none',
                    letterSpacing: '8px',
                    whiteSpace: 'nowrap', // Impede que o texto quebre em várias linhas
                    animation: 'floatingShadowAi 8s ease-in-out infinite alternate', // Efeito flutuante padrão
                    transform: 'translateY(-50%)'
                  }}
                >
                  I.A. CORE
                </div>
                
                <h2 className="mb-0 text-uppercase position-relative" style={{ lineHeight: '1.2', zIndex: 1 }}>
                  <span className="d-block" style={{ fontSize: 'clamp(3rem, 6vw, 5rem)', fontWeight: 'bold', color: '#ffffff', textShadow: '0 2px 10px rgba(0,243,255,0.3)', letterSpacing: '-1px' }}>
                    INTELIGÊNCIA<br/>ARTIFICIAL
                  </span>
                </h2>
              </div>
              
              <div className="d-flex position-relative mt-4 mb-5" style={{ zIndex: 2 }}>
                <div 
                  style={{
                    width: '4px',
                    backgroundColor: '#00f3ff',
                    boxShadow: '0 0 10px #00f3ff, 0 0 20px rgba(0, 243, 255, 0.6)',
                    borderRadius: '2px',
                    marginRight: '20px',
                    flexShrink: 0
                  }}
                ></div>
                <p className="mb-0" style={{ 
                  color: '#e9ecef', 
                  fontSize: 'clamp(1.1rem, 1.4vw, 1.4rem)', 
                  fontWeight: '300', 
                  maxWidth: '700px', // Expandido um pouco
                  lineHeight: '1.6'
                }}>
                  Nossa I.A. atua como verdadeira parceira do professor no dia a dia. Ela estrutura o planejamento com <strong>treinos automáticos e inteligentes</strong> para provas específicas criadas por você, focando sempre em facilitar a gestão e entregar o <strong style={{color: '#fff'}}>melhor desempenho</strong> aos seus alunos.
                </p>
              </div>

              {/* Box com Processamento Terminal AI (Movido para a esquerda, sob o texto) */}
              <div style={{
                background: 'rgba(32, 38, 52, 0.65)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(0, 243, 255, 0.2)',
                borderRadius: '16px',
                padding: '25px',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.5)',
                textAlign: 'left',
                maxWidth: '520px',
                position: 'relative',
                zIndex: 2,
                marginTop: '10px'
              }}>
                {/* Header Terminal */}
                <div className="d-flex align-items-center mb-4 pb-3" style={{ borderBottom: '1px solid rgba(255,255,255,0.05)' }}>
                  <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#ff5b5b', marginRight: '8px' }}></div>
                  <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#f1c40f', marginRight: '8px' }}></div>
                  <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#2ecc71', marginRight: '15px' }}></div>
                  <span style={{ color: '#00f3ff', fontFamily: 'monospace', fontSize: '0.85rem', letterSpacing: '1px', opacity: '0.9' }}>neo_ai_core_v2.sh</span>
                </div>

                {/* Textos Processando */}
                <div style={{ fontFamily: 'monospace', color: '#a6b0cf', fontSize: '0.95rem', lineHeight: '1.9' }}>
                  <p className="mb-2"><span style={{ color: '#00f3ff' }}>&gt;</span> Identificando objetivo da prova específica...</p>
                  <p className="mb-2"><span style={{ color: '#00f3ff' }}>&gt;</span> Processando parâmetros de desenvolvimento...</p>
                  <p className="mb-2"><span style={{ color: '#00f3ff' }}>&gt;</span> Auxiliando no planejamento do professor...</p>
                  <p className="mb-4"><span style={{ color: '#00f3ff' }}>&gt;</span> Estruturando ciclos da planilha semanal...</p>
                  
                  {/* Resultado Sucesso */}
                  <div style={{ 
                    background: 'rgba(0, 243, 255, 0.15)', 
                    borderLeft: '3px solid #00f3ff', 
                    padding: '12px 16px', 
                    color: '#00f3ff', 
                    fontWeight: 'bold',
                    borderRadius: '0 6px 6px 0',
                    animation: 'pulseBoxGlow 2s infinite alternate',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <i className="mdi mdi-check-circle-outline me-2" style={{ fontSize: '1.4rem' }}></i>
                    <div>
                      <span className="d-block" style={{ fontSize: '0.95rem' }}>Planilha de Treino Gerada com Sucesso <span style={{ animation: 'blink 1s step-end infinite' }}>_</span></span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </Col>

          {/* Coluna da Direita Vazia para exibir bem a imagem ia.png de fundo */}
          <Col lg={5} className="d-none d-lg-block">
          </Col>
        </Row>

        {/* Global Styles for Animations */}
        <style>
          {`
            @keyframes floatingShadowAi {
              from { transform: translateY(-50%) translateX(0px); }
              to { transform: translateY(-50%) translateX(-15px); }
            }
            @keyframes pulseBoxGlow {
              0% { box-shadow: 0 0 0 0 rgba(0, 243, 255, 0); }
              100% { box-shadow: 0 0 15px rgba(0, 243, 255, 0.2); }
            }
            @keyframes blink {
              0%, 100% { opacity: 1; }
              50% { opacity: 0; }
            }
            @keyframes fadeInLeft {
              from { opacity: 0; transform: translateX(-40px); }
              to { opacity: 1; transform: translateX(0); }
            }
          `}
        </style>
      </Container>
    </div>
  );
};

export default AiFeaturesSection;
